<template>
  <div
    v-if="office"
    class="grid"
  >
    <div class="container">
      <Toolbar class="mt-2 mb-2">
        <template #start>
          <h2>{{ $t("nav.officeDetail") }}</h2>
        </template>

        <template #end>
          <Button
            :label="$t('action.back')"
            icon="pi pi-arrow-left"
            class="p-button-secondary p-button-rounded p-button-outlined"
            @click="toOfficeTable"
          />
        </template>
      </Toolbar>


      <Panel class="mb-3">
        <template #header>
          <p class="font-bold">
            {{ $t('officedetailpage.fieldset.site') }}
          </p>
        </template>
        <div class="card_details ">
          <div class="card_body">
            <ul class="flex justify-content-between">
              <li>
                {{ $t('entity.office.site') }} : <strong> {{ office.site.name }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </Panel>


      <Panel>
        <template #header>
          <p class="font-bold">
            {{ $t('officedetailpage.fieldset.office') }}
          </p>
        </template>
        <div class="card_details ">
          <div class="card_body">
            <ul class="flex justify-content-between">
              <li>
                <div class="address">
                  <ul>
                    <li>{{ $t('entity.office.name') }} : <strong>{{ office.name }}</strong></li>
                    <li>
                      {{ $t('entity.office.openDate') }} :
                      <strong class="font-bold data"> {{ office.openDate }}</strong>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <ul>
                  <li>
                    {{ $t('entity.office.state') }} : <strong>{{
                      office.enabled ? $t('entity.office.enabled') : $t('entity.office.disabled')
                    }}</strong>
                  </li>
                  <li>
                    {{ $t('entity.office.closeDate') }} :
                    <strong class="font-bold data"> {{ office.closeDate }}</strong>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </Panel>

      <Panel class="mt-3 mb-3">
        <template #header>
          <p class="font-bold">
            {{ $t('entity.office.planning') }}
          </p>
        </template>

        <div class="p-datatable p-component p-datatable-responsive-scroll p-datatable-striped mt-3">
          <div class="p-datatable-wrapper">
            <table class="p-datatable-table">
              <thead class="p-datatable-thead">
                <tr>
                  <th
                    v-for="col of columns"
                    :key="col.field"
                  >
                    {{ col.header }}
                  </th>
                </tr>
              </thead>
              <tbody class="p-datatable-tbody">
                <tr>
                  <td
                    v-for="col of columns"
                    :key="col.field"
                  >
                    <div
                      v-if="office.planning[col.field]"
                      :set="dayPlanning = office.planning[col.field]"
                    >
                      <p>
                        {{ $t('entity.planning.from') }} <strong> {{
                          timeFormat(dayPlanning.morningOpen)
                        }}</strong>
                        {{ $t('entity.planning.to') }} <strong>{{
                          timeFormat(dayPlanning.morningClose)
                        }} </strong>
                      </p>

                      <p>
                        {{ $t('entity.planning.from') }} <strong> {{
                          timeFormat(dayPlanning.afternoonOpen)
                        }}</strong>
                        {{ $t('entity.planning.to') }} <strong>{{
                          timeFormat(dayPlanning.afternoonClose)
                        }} </strong>
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>

import Panel from "primevue/panel";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import moment from "moment";

export default {
  name: 'UserDetail',
  components: { Panel, Toolbar, Button },
  data() {
    return {
      office: null,
    }
  },
  computed: {
    columns() {
      return [
        { field: 'mondayPlanning', header: this.$t('entity.planning.monday') },
        { field: 'tuesdayPlanning', header: this.$t('entity.planning.tuesday') },
        { field: 'wednesdayPlanning', header: this.$t('entity.planning.wednesday') },
        { field: 'thursdayPlanning', header: this.$t('entity.planning.thursday') },
        { field: 'fridayPlanning', header: this.$t('entity.planning.friday') },
        { field: 'saturdayPlanning', header: this.$t('entity.planning.saturday') },
        { field: 'sundayPlanning', header: this.$t('entity.planning.sunday') }
      ]
    }
  },
  async mounted() {
    try {
      this.office = await this.$officeService.fetchOffice(this.$route.params.id)
      if (!this.office) await this.$router.push("/office")
    } catch (e) {
      await this.$router.push("/office")
    }
  },
  methods: {
    timeFormat(time) {
      return moment(time, 'HH:mm:ss').format('HH:mm')
    },
    toOfficeTable() {
      this.$router.push({ name: 'office' })
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  float: right;
}

.card_details {
  span {
    float: none;
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  .card_header {
    .card_times {
      background: #f7f7f7;
      padding: 10px;
      font-weight: 600;
    }
  }

  .card_body {
    li {
      width: 25vw;
      padding: 5px 0;
    }

  }
}

::v-deep(div.p-panel-header) {
  padding: 0 1rem;
}

::v-deep(div.p-panel-content) {
  padding: 0.1rem 1rem;
}
</style>
